import { Controller } from 'stimulus'

// Click a step circle to toggle its explainer popover. Clicking elsewhere,
// another circle, or pressing Escape closes it. Implemented as a controller
// (not a one-time popover init) so it re-binds when the stepper is replaced by
// a turbo stream after pricing.
export default class extends Controller {
  static targets = ['step']

  connect() {
    this.onDocumentClick = this.onDocumentClick.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener('click', this.onDocumentClick)
    document.addEventListener('keydown', this.onKeydown)
  }

  disconnect() {
    document.removeEventListener('click', this.onDocumentClick)
    document.removeEventListener('keydown', this.onKeydown)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const step = event.currentTarget.closest('[data-workflow-steps-target="step"]')
    if (!step) return

    const willOpen = !step.classList.contains('is-open')
    this.closeAll()
    if (willOpen) step.classList.add('is-open')
  }

  closeAll() {
    this.stepTargets.forEach((step) => step.classList.remove('is-open'))
  }

  onDocumentClick(event) {
    if (this.element.contains(event.target)) return

    this.closeAll()
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.closeAll()
  }
}
